export const PLAYBACK_MODAL_TITLE = 'Where should we play audio from?';

export const PLAYBACK_MODAL_SUBTITLE =
  'This determines if widget plays count as listens in your host dashboard';
